/** @format */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, useHistory } from "react-router-dom";
import { PATHS } from "./index";
import { getUrlSegment } from "./helper";

const PrivateRoute = ({ component: Component, roles, ...rest }) => {
	const history = useHistory();
	const { isAuth, nfRedirect, alluserdetails } = useSelector((state) => state.collections);

	let query = "";
	if (window.location?.search.includes("?nl=") && !isAuth) {
		history.push({
			pathname: PATHS.LANDINGPAGE + "?nl=" + true,
			state: { NlPath: window.location?.pathname },
		});
		window.location.assign(PATHS.LANDINGPAGE + "?nl=" + true);
		return false;
	}

	const urlArr = getUrlSegment();
	if(!isAuth && ["course-catalog", "userplan", "course-details"]?.includes(urlArr[0])){
		localStorage.setItem("urlRedirection", window.location?.pathname);
	}else if(isAuth && localStorage.getItem("urlRedirection")) {
			let getPath = localStorage.getItem("urlRedirection");
			let getUrlArr = localStorage.getItem("urlRedirection").split("/").filter((item)=>item !== "");
			if(getUrlArr[0] === "userplan" && getUrlArr?.length === 2){
				 history.push({
								pathname: "/"+ getUrlArr[0],
								state: { planCourseId: getUrlArr[1] }
						})
			}else{
				history.push(getPath);	
			}
			// console.log("getUrlSegment : ", 1)
			localStorage.removeItem("urlRedirection");
	}else if(isAuth && urlArr[0] === "userplan" && urlArr?.length === 2){
				 history.push({
								pathname: "/"+ urlArr[0],
								state: { planCourseId: urlArr[1] }
						})
				// console.log("getUrlSegment : ", 2)
	}

	// if ((urlArr[0] === "myplan" && urlArr?.length === 5) || (urlArr[1] === "social-lessons" && urlArr?.length >= 6) && !alluserdetails) {
	// 	localStorage.setItem("userRedirectPath", window.location?.pathname);
	// }

	return (
		<Route
			{...rest}
			render={(props) =>
				isAuth ? (
					<Component key="private-route-component" {...props} />
				) : (
					<Redirect
						key="private-route-redirect"
						to={{
							pathname: PATHS.LANDINGPAGE + query,
						}}
					/>
				)
			}
		/>
	);
};

export default PrivateRoute;
